// extracted by mini-css-extract-plugin
export default {"socials":"Socials_socials__mWOMv","item":"Socials_item__vLymw","share":"Socials_share__OHVFm","link":"Socials_link__Eih-i"};